import DialogName from '../constants/DialogName';
import hideDialog from './hideDialog';

export default function hideEditRuleWorksheet() {
  return hideDialog(DialogName.EDIT_RULE_WORKSHEET)();
}
